import Vue from 'vue'
import Vuex from 'vuex'
import createPersist from 'vuex-localstorage'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    token: null,
    user: null,
    userData: {},
    questionLang: null,
    currentGallery: null,
    currentMember: null
  },
  mutations: {
    SET_ADMINDATA (state, user) {
      state.token = user.token
      state.userData.fullName = user.fullName
      state.userData.email = user.email
      state.user = user.user
    },
    SET_EXERCISE_LANGUAGE (state, data) {
      state.questionLang = data.questionLang
    },
    CLEAR_ALL (state) {
      state.userData = {}
      state.token = null
      state.user = null
      state.currentGallery = null
      state.currentMember = null
    }
  },
  plugins: [createPersist({
    namespace: 'PMGC',
    expires: 45 * 60 * 1e3 // expires in 45 minutes.
  })]
})



// WEBPACK FOOTER //
// ./src/store/store.js